import 'firebase-utils';

import { getValue } from 'firebase/remote-config';
import { config } from 'firebase-utils/remoteConfig';

export function useConfig(key: string) {
  const value = getValue(config, key);
  return value;
}
